import { MainRule } from './MainRule'
export class StateRule {
    static validate(currentState, actionName){
        if(MainRule[currentState] && MainRule[currentState][actionName]){
            return true;
        }
        if(typeof onError === 'function') {
            const error = { code: 7 , message: "Invalid function at the current State"}
            onError(error);
        }
        return false;
    }
}


// WEBPACK FOOTER //
// ./src/BusinessRule/StateRule.js